<mat-card class="max-w-[25rem]">
  <mat-card-content class="flex flex-col gap-y-3">
    <div class="text-headline-large">Your verification link has expired.</div>
    <div class="text-body-large py-5">
      <p>This link is no longer active. Verification links expire after 24 hours for security reasons.</p>
      <p>No worries! Just request a new one and we'll send it right over.</p>
    </div>
    <mx-filled-button label="Resend Verification Email" (click)="onClickResend()"/>
  </mat-card-content>
</mat-card>
<div class="max-w-[50%] overflow-hidden ml-4">
  <img ngSrc="/assets/registration/verify-email-expired.svg" priority width="268" height="241" alt=""
       class="hidden md:flex md:max-w-[16.75rem]"/>
</div>
